<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>配置中心</el-breadcrumb-item>
          <el-breadcrumb-item>收费项目配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">收费名称:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.projectName" size="small"
                @keyup.enter.native="searchPayProject">
              </el-input>
            </div>
          </el-col>
          <el-col :span="18" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
              <el-button class="search-btn btn-gray" @click="clearConditions">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchPayProject">搜索</el-button>
              <el-upload style="display: inline-block" action="/" :http-request="(file)=> uploadChargeDesc(file)" accept=".pdf" :show-file-list='false'>
                <el-button class="search-btn btn-blue" ref='uploadChargeDesc'>更新客户端收费说明</el-button>
              </el-upload>
              <el-button class="search-btn btn-blue" @click="newPayProject">新增</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="payProjectList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border
          height="550">
          <el-table-column type="index" align="center" label="序号" width="40">
          </el-table-column>
          <el-table-column prop="payName" align="center" label="收费项名称">
          </el-table-column>
          <el-table-column prop="payNameJp" align="center" label="收费项名称日文">
          </el-table-column>
          <el-table-column prop="payPrice" align="center" label="单价">
          </el-table-column>
          <el-table-column prop="notes" label="备注">
          </el-table-column>
          <el-table-column prop="sortKey" align="center" label="排序">
          </el-table-column>
          <el-table-column prop="useFlag" label="启用状态" align="center" :index="indexMethod" sortable :formatter="statusFormatter">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button style="margin: 5px" class="list-btn btn-blue" @click="editPayProject(scope.row)"
                :disabled="scope.row.editFlag != 0">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" @close="payProjectDialogClose">
      <el-form label-width="140px" class="add-role-form" :model="payProjectDialog" :rules="dataRule" ref="dialogForm">
        <el-form-item label="收费名称：" prop="payName">
          <el-input v-model="payProjectDialog.payName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收费名称日文：" prop="payName">
          <el-input v-model="payProjectDialog.payNameJp" size="small"></el-input>
        </el-form-item>
        <el-form-item label="单价：" prop="payPrice">
          <el-input v-model="payProjectDialog.payPrice" size="small"></el-input>
        </el-form-item>
        <el-form-item label="排序值：" prop="sortKey">
          <el-input v-model.number="payProjectDialog.sortKey" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="notes">
          <el-input v-model="payProjectDialog.notes" size="small"></el-input>
        </el-form-item>

        <el-form-item label="启用状态：">
          <el-switch v-model="payProjectDialog.useFlag" active-color="#13ce66" inactive-color="#909399" active-value="0"
            inactive-value="1">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closePayProjectDialog">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmEdit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
export default {
  name: 'payProjects',
  components: { tableCon },
  data () {
    return {
      dataRule: {
        payName: [
          { message: "收费项目名不能为空", trigger: "blur", required: true },
        ],
        payPrice: [
          { message: "价格不能为空", trigger: "blur", required: true },
          {
            validator: (rule, value, callback) => {
              var reg = /^\d{1,16}(?:\.\d{1,2})?$/; //小数点左边最高16位，小数点右边最多2位
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error("输入正确的数字,小数点后可1到2位"));
              }
            },
            trigger: "blur",
          },
        ],
        sortKey: [
          { message: "排序值不能为空", trigger: "blur", required: true },
          { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        notes: [{ message: "备注不能为空", trigger: "blur", required: true }],
      },
      payProjectDialog: {
        id: 0,
        payName: "",
        payPrice: "",
        sortKey: 0,
        notes: "",
        useFlag: "0",
        payNameJp: ""
      },
      dialogTitle: "",
      dialogVisible: false,
      queryInfo: {
        projectName: "",
        pageSize: 10,
        pageNum: 1,
      },
      payProjectList: [],
      total: 0,
    };
  },
  methods: {
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    confirmEdit () {
      var my = this;
      this.$refs.dialogForm.validate(async function (valid) {
        if (valid) {
          const { data: res } = await my.$http.post(
            "/configPayProject/addOrUpdate",
            my.payProjectDialog
          );
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.dialogVisible = false;
            my.getPayProjectList();
          } else {
            my.$message.error(res.message);
          }
        }
      });
    },
    uploadChargeDesc(file){
      let formdata = new FormData();
      formdata.append('file', file.file);
      this.$http.post('aliyun/oss/uploadChargeDesc', formdata).then(res => {
        if(res.data.code==200){
          this.$message.success('操作成功')
        }else{
          this.$message.error(res.data.message)
        }
      })
    },
    closePayProjectDialog () {
      this.dialogVisible = false;
    },
    dialogInit () {
      this.payProjectDialog.id = 0;
      this.payProjectDialog.payName = "";
      this.payProjectDialog.payPrice = "";
      this.payProjectDialog.sortKey = 0;
      this.payProjectDialog.notes = "";
      this.payProjectDialog.useFlag = "0";
    },
    payProjectDialogClose () { },
    newPayProject () {
      this.dialogInit();
      this.dialogType = 1;
      this.dialogTitle = "新增收费项";
      let _this = this;
      this.$nextTick(function () {
        _this.$refs.dialogForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    editPayProject (row) {
      this.dialogInit();
      this.dialogType = 0;
      this.dialogTitle = "修改收费项";
      this.dialogInitialize(row);
      let _this = this;
      this.$nextTick(function () {
        _this.$refs.dialogForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    dialogInitialize (row) {
      this.payProjectDialog.id = row.id;
      this.payProjectDialog.payName = row.payName;
      this.payProjectDialog.payPrice = row.payPrice;
      this.payProjectDialog.sortKey = row.sortKey;
      this.payProjectDialog.notes = row.notes;
      this.payProjectDialog.useFlag = row.useFlag;
      this.payProjectDialog.payNameJp = row.payNameJp;
    },
    statusFormatter (row, column) {
      if (row.useFlag == 0) {
        return "启用";
      } else {
        return "禁用";
      }
    },
    createDateRange () { },
    searchPayProject () {
      this.queryInfo.pageNum = 1;
      this.getPayProjectList();
    },
    handleSizeChange (pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getPayProjectList();
    },
    handleCurrentChange (pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getPayProjectList();
    },
    clearConditions () {
      this.queryInfo.projectName = "";
    },
    async getPayProjectList () {
      const { data: res } = await this.$http.get(
        "configPayProject/payProjectList",
        {
          params: this.queryInfo,
        }
      );
      this.payProjectList = res.data.list;
      this.total = res.data.total;
    },
  },
  created () {
    this.getPayProjectList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
